import { RESULT_BACKGROUNDS, RESULT_RATIOS, getBrandResultBackground } from "./resultAssets";
import {
    normalizeLO,
    normalizeLOColumnPairs,
    normalizeLOValueBuckets,
    normalizePosts,
} from "./resultData";
import { kpConfig } from "./resultLayouts/kpLayout";
import { mcConfig } from "./resultLayouts/mcLayout";
import { mtConfig } from "./resultLayouts/mtLayout";
import {
    COMMON_NIGHT_ZONES,
    DEFAULT_LO_LAYOUT,
    DEFAULT_POST_AREA,
    DEFAULT_POST_TYPOGRAPHY,
    KH_DAY_ZONES,
    LEAP_DAY_ZONES,
    LEAP_DAY_POST_AREA,
    MC_DAY_ZONES,
    SC_DAY_ZONES,
    createSimpleLotteryConfig,
    createStandardLayout,
    toPercentStyle,
} from "./resultLayouts/sharedLayouts";
import { tcConfig } from "./resultLayouts/tcLayout";
import { TEXT_STYLES } from "./resultTheme";

const khConfig = createSimpleLotteryConfig({
    bg: RESULT_BACKGROUNDS.KH,
    ratio: RESULT_RATIOS.KH,
    zones: KH_DAY_ZONES,
    textStyle: TEXT_STYLES.kh,
    postArea: {
        frame: { left: 27, width: 68 },
        rows: {
            startTop: 27.5,
            rowHeight: 9.5,
        },
    },
    postTypography: DEFAULT_POST_TYPOGRAPHY,
    loLayout: DEFAULT_LO_LAYOUT,
});

const scConfig = createSimpleLotteryConfig({
    bg: RESULT_BACKGROUNDS.SC,
    ratio: RESULT_RATIOS.SC,
    zones: SC_DAY_ZONES,
    textStyle: TEXT_STYLES.sc,
    postArea: {
        ...DEFAULT_POST_AREA,
        frame: { left: 26.5, width: 62 },
        rows: {
            startTop: 26.3,
            rowHeight: 10.5,
        },
    },
});

const leapConfig = createSimpleLotteryConfig({
    bg: RESULT_BACKGROUNDS.LEAP,
    ratio: RESULT_RATIOS.LEAP,
    zones: LEAP_DAY_ZONES,
    textStyle: TEXT_STYLES.leap,
    postArea: LEAP_DAY_POST_AREA,
    postCodes: ["A", "B", "C", "D", "F", "I", "N"],
    postValueKeys: ["twoDigit", "threeDigit", "fourDigit"],
    postValueColumns: ["0.75fr", "0.95fr", "1.3fr"],
    postTypography: DEFAULT_POST_TYPOGRAPHY,
    loLayout: DEFAULT_LO_LAYOUT,
});

const defaultConfig = {
    bg: RESULT_BACKGROUNDS.DEFAULT,
    layout: {
        DAY: createStandardLayout({
            ratio: RESULT_RATIOS.DEFAULT.DAY,
            zones: MC_DAY_ZONES,
            textStyle: TEXT_STYLES.mc,
            postArea: DEFAULT_POST_AREA,
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: DEFAULT_LO_LAYOUT,
        }),
        NIGHT: createStandardLayout({
            ratio: RESULT_RATIOS.DEFAULT.NIGHT,
            zones: COMMON_NIGHT_ZONES,
            textStyle: TEXT_STYLES.mc,
            postArea: DEFAULT_POST_AREA,
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: DEFAULT_LO_LAYOUT,
        }),
    },
};

export const LOTTERY_CONFIG = {
    MC: mcConfig,
    MT: mtConfig,
    TC: tcConfig,
    KP: kpConfig,
    KP_MC: { ...kpConfig, bg: RESULT_BACKGROUNDS.KP_MC },
    KH: khConfig,
    SC: scConfig,
    LEAP: leapConfig,
    DEFAULT: defaultConfig,
};

export function getMode(isNight) {
    return isNight === true || isNight === "true" ? "NIGHT" : "DAY";
}

export function getLotteryConfig(lotteryType) {
    const type = String(lotteryType || "").toUpperCase();
    return LOTTERY_CONFIG[type] || LOTTERY_CONFIG.DEFAULT;
}

export function getResultBackground(lotteryType, isNight, brand = "p99") {
    return getBrandResultBackground(lotteryType, getMode(isNight), brand);
}

export function getResultLayout(lotteryType, isNight) {
    const config = getLotteryConfig(lotteryType);
    const mode = getMode(isNight);

    return config.layout?.[mode] || config.layout;
}

export function getZones(lotteryType, isNight) {
    return getResultLayout(lotteryType, isNight)?.zones || MC_DAY_ZONES;
}

export {
    normalizeLO,
    normalizeLOColumnPairs,
    normalizeLOValueBuckets,
    normalizePosts,
    toPercentStyle,
};
